<template>
  <div>
    <div class="row">
      <div class="col-12">
        <router-link :to="{ name:'AddExceptionRange' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
          Add Exception Range
        </router-link>
        <router-link :to="{ name:'RemoveExceptionRange' }" class="btn btn-outline-danger"><i class="fa fa-trash"
                                                                              aria-hidden="true"></i>
          Remove Exception Range
        </router-link>
      </div>
    </div>
    <br>
    <Calendar></Calendar>
  </div>
</template>

<script>
import Calendar from '../../../components/Scheduler/Calendar/Calendar'

export default {
  components: {
    Calendar
  }
}
</script>

<style scoped>

</style>
